import React from 'react';

function ToastNotification({ title, text, closeText, type, setShowToast }) {
    let className = ""

    switch (type) {
        case "success":
            className = "c-toast-notification--success";
            break;
        case "warning":
            className = "c-toast-notification--warning";
            break;
        case "error":
            className = "c-toast-notification--error";
            break;
        default:
            break;
    }

    return (
        <React.Fragment>
            <aside id="js-toast-notifications" className="c-toast-notifications  js-toast-notifications" aria-label={title}>
                <article className={"c-toast-notification " + className} aria-live="polite" role="status">
                    <div className="c-toast-notification__content">
                        <div className="c-toast-notification__body">
                            <p>{text}</p>
                        </div>
                        <button className="c-toast-notification__close  c-icon  c-icon--[semantic-close]" style={{ fontSize: "20px" }} type="button" title={closeText} onClick={() => setShowToast(false)}></button>
                    </div>
                </article>
            </aside>
        </React.Fragment>
    );
}

export default ToastNotification;